<script>
  import { createEventDispatcher } from 'svelte';
  import { categories, selectedChannelId } from '../../../Store/store';
  import { fade } from 'svelte/transition';
  import { getCategoryDisplayName } from '../../../common/utils';
  import { formatShortDate } from '../../../common/dates';

  const dispatch = createEventDispatcher();

  export let channels = [];
</script>

<div class="channel-list-container">
  <div class="channels">
    {#each channels as channel}
      <div
        class="channel-container"
        class:live={channel.live === true}
        class:selected={$selectedChannelId === channel.id}
        on:click={() => dispatch('channelclicked', { channel })}
        in:fade
      >
        <div class="info">
          <div class="type-date">
            <p class="type">
              {getCategoryDisplayName($categories, channel.category)}
            </p>
            <p class="date">
              {channel.created ? formatShortDate(channel.created.toDate()) : ''}
            </p>
          </div>
          <p class="name">{channel.name}</p>
        </div>
        <div class="details">
          {#if channel.political}
            <div class="political-chat">
              <span class="material-icons"> security </span>
            </div>
          {/if}
          <div class="light" class:live={channel.live === true}>
            {#if channel.roomId}
              <span class="material-icons icon"> videocam </span>
            {/if}
            {channel.live ? 'Live' : '-'}
          </div>
        </div>
      </div>
    {/each}
  </div>
</div>

<style src="./channelsList.scss">
</style>
